<template>
  <LayoutWrapper>
    <DmgwBoard />
  </LayoutWrapper>
</template>
<script setup lang="ts">
import LayoutWrapper from '@/components/LayoutWrapper.vue';
import DmgwBoard from '@/components/DmgwBoard/DmgwBoard.vue';
</script>
